import { Sparkles, Plus, Wand2, MessageSquare } from 'lucide-react'
import { Button } from '@lovable/components/ui/button'
import { t } from 'i18next'

interface QuickActionsBarProps {
  onAction: (action: string, prompt: string) => void
  hasLenseSelected?: boolean
  readyTasks?: boolean
}

export function QuickActionsBar({ onAction, hasLenseSelected = false, readyTasks }: QuickActionsBarProps) {
  const actions = readyTasks
    ? [
        {
          icon: Plus,
          label: t('engine.quick_action_parse_more', 'Parse more tasks'),
          prompt: t('engine.quick_action_parse_more_prompt', 'Please revise the source document if more tasks can be found for my game'),
          variant: 'outline' as const,
        },
      ]
    : [
        {
          icon: Plus,
          label: t('engine.quick_action_generate','Generate more tasks'),
          prompt: t('engine.quick_action_generate_prompt','Please enerate more tasks for my game'),
          variant: 'outline' as const,
        },
        {
          icon: Wand2,
          label: t('engine.quick_action_elaborate', 'Elaborate story'),
          prompt: t('engine.quick_action_elaborate_prompt','Please ensure that all tasks have the story part and elaborate the story a bit more'),
          variant: 'outline' as const,
        },
        {
          icon: MessageSquare,
          label: t('engine.quick_action_educational', 'More educational task'),
          prompt: t('engine.quick_action_educational_prompt', "Add an educational section at the beginning of the task ___ to teach players about the task's theme."),
          variant: 'outline' as const,
        },
        {
          icon: MessageSquare,
          label: t('engine.quick_action_rephrase', 'Rephrase tasks'),
          prompt: t('engine.quick_action_rephrase_prompt', 'Rephrase the tasks to be more engaging and clear'),
          variant: 'outline' as const,
        },
        {
          icon: Sparkles,
          label: t('engine.quick_action_clarity', 'Improve clarity'),
          prompt: t('engine.quick_action_clarity_prompt', 'Review the game and make improvements for clarity and difficulty balance'),
          variant: 'outline' as const,
        },
      ]

  return (
    <div className='space-y-3'>
      <div className='flex items-center gap-2'>
        <Sparkles className='w-4 h-4 text-primary' />
        <p className='text-sm font-medium text-foreground'>{t('engine.quick_actions','Quick Actions')}</p>
      </div>
      <div className='grid grid-cols-1 gap-2'>
        {actions.map((action, index) => {
          const Icon = action.icon
          return (
            <Button
              key={index}
              variant={action.variant}
              size='sm'
              onClick={() => onAction(action.label, action.prompt)}
              className='justify-start text-left h-auto py-2 quick-action-override'
            >
              <Icon className='w-4 h-4 mr-2 shrink-0' />
              <span className='text-xs'>{action.label}</span>
            </Button>
          )
        })}
      </div>
    </div>
  )
}
